import getHelper from '../../../services/getHelper';
import TeamsHelper from './organizations/TeamsHelper';
import AnalyticsHelper from './AnalyticsHelper';
import InvitationsHelper from './InvitationsHelper';

import withBulkedInvitations from './withBulkedInvitations';

const OrganizationsHelper = getHelper('/organizations/:id', {
  teams: TeamsHelper,
  analytics: AnalyticsHelper,
  users: getHelper('/users/:id', {
    roles: getHelper('/roles/:id'),
  }),
  invitations: InvitationsHelper,
});

export default withBulkedInvitations(OrganizationsHelper);
